import { FileText, CalendarCheck, Truck } from "lucide-react";

const steps = [
  { icon: FileText, num: "1", title: "Get a Quote", desc: "Fill out our simple form or give us a call. We'll get back to you fast." },
  { icon: CalendarCheck, num: "2", title: "Book Your Move", desc: "Pick a date and time that works for you. Easy as that." },
  { icon: Truck, num: "3", title: "We Move Everything", desc: "Our team shows up, loads up, and delivers, safely and on time." },
];

const HowItWorks = () => (
  <section id="how-it-works" className="bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        How It Works
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        Three simple steps to a stress-free move.
      </p>
      <div className="grid md:grid-cols-3 gap-10 max-w-4xl mx-auto">
        {steps.map((s) => (
          <div key={s.num} className="text-center">
            <div className="w-20 h-20 bg-yellow rounded-full flex items-center justify-center mx-auto mb-5">
              <s.icon className="w-9 h-9 text-dark" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-2">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <a
          href="#quote"
          className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
        >
          Get Started - It's Free
        </a>
      </div>
    </div>
  </section>
);

export default HowItWorks;
